"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadJson = void 0;
var loadJson = function (_a) {
    var url = _a.url, onSuccess = _a.onSuccess, onError = _a.onError, _b = _a.tries, tries = _b === void 0 ? 1 : _b, _c = _a.retryDelay, retryDelay = _c === void 0 ? 1000 : _c;
    var xmlHttp = new XMLHttpRequest();
    var errorHandler = function (statusCode, statusText) {
        if (tries <= 1) {
            onError(statusCode, statusText);
        }
        else {
            setTimeout(function () {
                (0, exports.loadJson)({ url: url, onSuccess: onSuccess, onError: onError, tries: tries - 1, retryDelay: retryDelay });
            }, retryDelay);
        }
    };
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === XMLHttpRequest.DONE) {
            if (xmlHttp.status === 200) {
                var data = JSON.parse(xmlHttp.responseText);
                onSuccess(data);
            }
            else {
                errorHandler(xmlHttp.status, xmlHttp.statusText);
            }
        }
    };
    xmlHttp.onerror = function () {
        errorHandler(this.status, this.statusText);
    };
    xmlHttp.ontimeout = function () {
        errorHandler(this.status, this.statusText);
    };
    xmlHttp.open("GET", url);
    xmlHttp.setRequestHeader('Accept', 'application/json');
    xmlHttp.send();
};
exports.loadJson = loadJson;
//# sourceMappingURL=rest.js.map